
"use client";
import React from "react";
import Link from "next/link";
import { Typography, Carousel } from "antd";
import "./CategoriesHeader.scss";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { usePathname } from "next/navigation";

const { Text } = Typography;

export default function CategoriesHeader({ data, userAgent }) {
  const pathName = usePathname();
  const categories = data?.header_list || [];


  const { isMobile, isDesktop } = userAgent;

  const carouselSettings = {
    swipe: true,
    dots: true,
    infinite: false,
    autoplay: false,
    arrows: false,
    slidesToShow: isDesktop ? 4 : 1,
    slidesToScroll: isDesktop ? 1 : 1,
  };



  if (!categories.length) return null;

  return isMobile ? (
    <div className="CategoriesHeader">
      {pathName === "/" && (
        <div className="sectionHeadingContainer">
          <Text className="sectionHeadingMobileBold">
            Trending Categories
          </Text>
        </div>
      )}

      <div className="categories-carousel-container">
        <Carousel {...carouselSettings}>
          {categories.map((cat, index) => (
            <div key={index} className="padding5">
              <Link href={cat?.handle || "#"} className="category-item">
                <div className="category-content">
                  <div className="category-image-container">
                    <LazyLoadImage
                      src={cat?.category_image}
                      alt={cat?.category_image_alt_text}
                      className="category-icon"
                    />
                  </div>

                  <div className="category-info">
                    <Text className="category-name">{cat?.name}</Text>
                    <Text className="category-subtitle">
                      {cat?.category_image_alt_text || "Collection"}
                    </Text>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Carousel>

      </div>
    </div>
  ) : (
    <div className="categoriesHeaderDesktop">
      <div className="sectionHeadingContainer">
        {data?.title && (
          <Typography className="font26 text-uppercase">
            {data.title}
          </Typography>
        )}
        <Link href={data?.button_link || "/collections"} className="shop-all-link">
          SHOP ALL <span className="arrow">›</span>
        </Link>
      </div>

      <div className="categories-carousel-container">
        <Carousel {...carouselSettings}>
          {categories.map((cat, index) => (
            <div key={index} className="padding5">
              <Link href={cat?.handle || "#"} className="category-item">
                <div className="category-content">
                  <div className="category-image-container">
                    <LazyLoadImage
                      src={cat?.category_image}
                      alt={cat?.category_image_alt_text}
                      className="category-icon"
                    />
                  </div>

                  <div className="category-info">
                    <Text className="category-name">{cat?.name}</Text>
                    <Text className="category-subtitle">
                      {cat?.category_image_alt_text || "Collection"}
                    </Text>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
}
